'use client'
import { SbBlokData, storyblokEditable } from '@storyblok/react/rsc'
import { FC } from 'react'

import { stylePanelSBData } from '../../../lib/stylePanel'
import useResponsivePadding from '../../../lib/useResponsivePadding'
import { PhnxHubspotform } from './Hubspotform'
import { HubspotformProps } from './Hubspotform'

interface HubspotformBlokProps {
  blok: {
    title: HubspotformProps['title']
    formId: string
    portalId?: string
    region?: string
    height?: number
    width?: number
    anchorTag?: string
    hiddenFields?: any
    background?: string | { value?: string }[]
    padding?: SbBlokData[]
  } & SbBlokData
}

const Hubspotform: FC<HubspotformBlokProps> = ({ blok }) => {
  let bgColor = 'transparent'
  if (typeof blok.background === 'string') {
    bgColor = blok.background
  } else if (Array.isArray(blok.background) && blok.background[0]?.value) {
    bgColor = blok.background[0].value
  }

  let stylePanel = stylePanelSBData(null, blok.background, null, blok.padding)
  const paddingStyles = useResponsivePadding(stylePanel.padding)
  const style = { ...paddingStyles, width: '100%', backgroundColor: bgColor }

  const mappedHiddenFields: { [field: string]: string } = {}
  if (Array.isArray(blok.hiddenFields)) {
    blok.hiddenFields.forEach((hf: any) => {
      if (hf?.fieldName && hf?.fieldValue) {
        mappedHiddenFields[hf.fieldName] = hf.fieldValue
      }
    })
  }

  return (
    <div {...storyblokEditable(blok)} style={style}>
      <PhnxHubspotform
        title={blok.title}
        formId={blok.formId}
        portalId={blok.portalId || '441838444'}
        region={blok.region || 'ap1'}
        height={blok.height ? blok.height + 'px' : undefined}
        width={blok.width ? blok.width + 'px' : undefined}
        anchorTag={blok.anchorTag || undefined}
        hiddenFields={mappedHiddenFields}
      />
    </div>
  )
}

export default Hubspotform
